<script lang="ts">
	import { Button } from "@ishavskraft/shared";
	import { RING_MEG_FORM_ID } from "#lib/ringMeg.js";
	import { telDial } from "#lib/utils/telDial.js";
	import RingMegModal from "#lib/RingMegModal.svelte";
	import { callbackFunctionIsDisabled } from "./utils/featureToggleUtils";

	const callbackDisabled = callbackFunctionIsDisabled();

	type Props = {
		lang?: string | null;
		title?: string | null;
		phoneLabel?: string | null;
		emailLabel?: string | null;
		contactForm?: boolean;
		customPhone?: string | undefined;
		customEmail?: string | undefined;
		// Inert post-HubSpot migration; preserved for callsite-prop compatibility.
		customFeedback?: string | undefined;
		showNameInput?: boolean;
		showMessageInput?: boolean;
		class?: string;
		children?: import("svelte").Snippet;
	};

	let {
		lang = null,
		title = null,
		phoneLabel = null,
		emailLabel = null,
		contactForm = true,
		customPhone = undefined,
		customEmail = undefined,
		customFeedback: _customFeedback = undefined,
		showNameInput: _showNameInput = true,
		showMessageInput: _showMessageInput = true,
		class: classes = "",
		children,
	}: Props = $props();

	let dialogOpen = $state(false);
	let contactPhone = $derived(customPhone ?? "776 12 000");
	let contactEmail = $derived(customEmail ?? "kunde@ishavskraft.no");
</script>

<section
	class="info_container py-4 mb-12 bg-$primary-white {classes} rounded-2xl mx-edge-x px-3 tablet:px-5"
	{lang}
>
	<h2 class="hyphens-manual mb-0">{title || "Har du andre spørsmål, ta gjerne kontakt med oss"}</h2>

	<address class="not-italic text-body children-my-0">
		<p class="mb-2">
			{phoneLabel || "Ring oss på"}
			<a class="hyphens-manual" href="tel:{telDial(contactPhone)}">{contactPhone}</a>
		</p>
		<p>
			{emailLabel || "Send oss en mail på"}
			<a class="hyphens-manual" href="mailto:{contactEmail}">{contactEmail}</a>
		</p>
	</address>

	{#if contactForm && !callbackDisabled}
		<p class="text-body mt-2">Eller vi kan kontakte deg</p>
		<p>
			<Button primary onclick={() => (dialogOpen = true)}>Ring meg!</Button>
		</p>
	{/if}

	{@render children?.()}
</section>

<RingMegModal bind:open={dialogOpen} formId={RING_MEG_FORM_ID} />

<style>
	.info_container {
		display: flex;
		flex-direction: column;
	}

	a {
		font-weight: 600;
	}
</style>
